import * as React from "react";

import * as moment from "moment";

import { Format } from "@common/_constants";

interface LocalTimeProps {
    utcTimestamp: string
    format?: string
}


const LocalTime = (props: LocalTimeProps) => {
    const format = props.format || Format.Datetime.DATETIME_ABBR_MONTH;
    const localTime = moment
        .utc(props.utcTimestamp)
        .local()
        .format(format);
    return <span className="c-local-time">{localTime}</span>;
};

export default LocalTime;
